import { MeterType } from "@next-platform/packages-ts-types";
/** Every meter `icon` name a platform icon set must draw. Aliases keep older data drawing. */
export const METER_ICON_KEYS = [
    "heart",
    "shield",
    "shield_check",
    "search",
    "flame",
    "spark",
    "sparkle",
    "flag",
    "coin",
    "coins",
    "dice",
    "star",
    "bolt",
    "gem",
    "moon",
    "sun",
    "skull",
    "drop",
    "key",
    "crown",
    "eye",
    "book",
    "sword",
    "leaf",
    "music",
    "target",
    "brain",
    "clock",
    "coffee",
    "info",
];
/** Meter `icon` names offered by the Studio icon picker, in picker order. */
export const METER_ICON_NAMES = [
    "heart",
    "shield",
    "search",
    "flame",
    "spark",
    "flag",
    "coin",
    "dice",
    "star",
    "bolt",
    "gem",
    "moon",
    "sun",
    "skull",
    "drop",
    "key",
    "crown",
    "eye",
    "book",
    "sword",
    "leaf",
    "music",
    "target",
    "brain",
    "clock",
];
const METER_ICON_KEY_SET = new Set(METER_ICON_KEYS);
const isMeterIconKey = (iconName) => METER_ICON_KEY_SET.has(iconName);
/** The known icon key for a meter `icon` name (case-insensitive), or `undefined` for unknown/empty names. */
export const lookupMeterIconKey = (iconName) => {
    const normalizedName = iconName?.toLowerCase();
    return normalizedName && isMeterIconKey(normalizedName) ? normalizedName : undefined;
};
/** A meter's icon key: Clock meters always draw the clock; otherwise the known icon, or the dice/spark fallback. */
export const resolveMeterIconKey = ({ icon, meterType }) => {
    if (meterType === MeterType.CLOCK) {
        return "clock";
    }
    return lookupMeterIconKey(icon) ?? (meterType === MeterType.DICE ? "dice" : "spark");
};
